import React from 'react'
import styled from 'styled-components'
import { breakpoints } from '../../../constants/breakpoints.constants'

export const PushButtonStoreContainer = styled.div`
	border-bottom: 1px solid #dedede;
	justify-content: space-between;
	flex-direction: row;
	margin-bottom: 30px;
	align-items: center;
	max-width: 425px;
	display: none;
	margin: auto;
	padding: 5px;

	@media screen and (max-width: ${breakpoints.MOBILE}px) {
		display: flex;
	}

	img {
		width: 60px;
		border: 2px solid #dedede;
		border-radius: 10px;
	}

	p {
		flex-direction: column;
		padding: 0px 5px;
		margin: 0px;
		display: flex;
		text-align: center;

		span:first-child {
			font-weight: bold;
			font-size: 16px;
		}

		span {
			font-size: 14px;
			line-height: 20px;
		}
	}

	a {
		background-color: #007bff;
		align-content: center;
		text-align: center;
		border-radius: 50%;
		font-size: 14px;
		padding: 10px;
		color: white;
		border: none;
		height: 55px;
	}
`
